import { Component, Input, OnInit } from '@angular/core';
import { EasternTimeDatePipe } from '@nationwide/internet-servicing-angular-pipes';
import { NgClass } from '@angular/common';
import { SaveAsRefundConfimationDetailsComponent } from '../../../../../../shared/payments/save-as-refund-confirmation-details/save-as-refund-confirmation-details.component';

@Component({
    selector: 'app-saved-payment-confimation-details',
    templateUrl: './saved-payment-confimation-details.component.html',
    styleUrls: ['./saved-payment-confimation-details.component.scss'],
    imports: [NgClass, SaveAsRefundConfimationDetailsComponent]
})

export class SavedPaymentConfimationDetailsComponent implements OnInit {
    @Input() paymentMethod: PaymentMethodConfirmationDetail;
    @Input() saveVerb = 'Saved';
    @Input() addPaymentMethodError: boolean;
    @Input() successfulRefundMethodEnrollments: string[] = [];
    @Input() unsuccessfulRefundMethodEnrollments: string[] = [];
    @Input() isPaperlessEnrollmentUnsuccessful: boolean;
    @Input() errorMessage: string;
    effectiveDate = new Date();
    formattedCurrentDate: string;

    constructor(private easternTimeDatePipe: EasternTimeDatePipe) { }

    ngOnInit(): void {
        this.setFormattedCurrentDate();
    }

    setFormattedCurrentDate(): void {
        const dateFormat = 'MM/dd/yyyy, hh:mm aa ';
        this.formattedCurrentDate = `${this.easternTimeDatePipe.transform(new Date(), dateFormat)}ET`;
    }
}

export interface PaymentMethodConfirmationDetail {
    paymentType: string;
    maskedNumber: string;
}
